import { markdown } from "markdown";
import { Row } from "./row";

export const Levels = [
  0,
  50, // Level 2
  100, // Level 3
  200, // Level 4
  400, // Level 5
  600, // Level 6
  800, // Level 7
  1000, // Level 8
  1200, // Level 9
  1500, // Level 9
  2000, // Level 10
  2500, // Level 11
  3000, // Level 12
  3500, // Level 13
  4000, // Level 14
  5000, // Level 15
  6000, // Level 16
  7000, // Level 17
  8000, // level 18
  9000, // Level 19
  10000, // Level 20
  12500, // Level 21
  15000, // Level 22
  17500, // Level 23
  20000, // Level 24
  25000, // Level 25
  30000, // Level 26
  35000, // Level 27
  40000, // Level 28
  50000, // Level 29
  60000, // Level 30
];

export function makeAnonUser(): User {
  return new User({
    id: -1,
    experience: 0,
    experience_art: 0,
    experience_story: 0,
    ip: [],
    username: "Anonymous Chip",
    password: "anonymous chip",
    trusted: false,
    profile_picture: "/img/anonymous-chip.png",
    avatar_url: "/img/anonymous-chip.png",
    send_email: false,
    weight: 0,
    send_notification_emails: false,
    created: new Date(),
    profile: "",
    banned: false,
    supporter: false,
    coins: 0,
    play_visibility: "none",
    email: "anonymous@chip.com",
    invited_by: "johnfn",
    admin: false,
    cacao: false,
    judge: false,
  });
}

export interface UserJSON {
  id: number;

  experience: number;
  experience_art: number;
  experience_story: number;
  ip: any[];
  username: string;
  password: string;
  send_email: boolean;
  banned: boolean;
  supporter: false;
  weight: number;
  send_notification_emails: boolean;
  profile_picture: string;
  created: Date;
  profile: string;
  email: string;
  trusted: boolean;
  judge: boolean;
  invited_by: string;
  avatar_url: string;
  coins: number;
  cacao: boolean;
  play_visibility: "over5" | "all" | "none";

  admin: boolean;

  // Impersonation fields (optional, set when user ID 1 is assuming another user)
  _isAssuming?: boolean;
  _assumingAs?: string;
}

// client side
export class User extends Row<UserJSON> implements UserJSON {
  declare id: number;

  declare experience: number;
  declare experience_art: number;
  declare experience_story: number;
  declare username: string;
  declare password: string;
  declare send_email: boolean;
  declare ip: any[];
  declare trusted: boolean;
  declare send_notification_emails: boolean;
  declare profile_picture: string;
  declare created: Date;
  declare profile: string;
  declare email: string;
  declare judge: boolean;
  declare banned: boolean;
  declare invited_by: string;
  declare avatar_url: string;
  declare supporter: false;
  declare coins: number;
  declare play_visibility: "over5" | "all" | "none";
  declare weight: number;
  declare cacao: boolean;

  declare admin: boolean;

  // Impersonation fields
  declare _isAssuming?: boolean;
  declare _assumingAs?: string;

  notifications: string[] = [];

  constructor(props: UserJSON) {
    super(props);

    this.created = new Date(this.created);
  }

  get linkToUser(): string {
    return "/user/" + this.username;
  }

  get level(): number {
    for (let i = 0; i < Levels.length; i++) {
      if (Levels[i] >= this.experience) {
        return i;
      }
    }

    return 999;
  }

  get level_art(): number {
    for (let i = 0; i < Levels.length; i++) {
      if (Levels[i] >= this.experience_art) {
        return i;
      }
    }

    return 999;
  }

  get level_story(): number {
    for (let i = 0; i < Levels.length; i++) {
      if (Levels[i] >= this.experience_story) {
        return i;
      }
    }

    return 999;
  }

  /**
   * this is ACTUALLY the amount of gold you have. Not silver. Not total coins.
   */
  get gold(): number {
    return Math.floor(this.coins / 20);
  }

  /**
   * this is ACTUALLY the amount of silver you you have. Not total coins.
   */
  get silver(): number {
    return Math.floor(this.coins % 20);
  }

  get urlToProfile(): string {
    return "/user/" + this.username;
  }

  get nextLevelExpRequired(): number {
    for (let i = 0; i < Levels.length; i++) {
      if (Levels[i] > this.experience) {
        return Levels[i] - (i === 0 ? 0 : Levels[i - 1]);
      }
    }

    return 999;
  }

  get expToNextLevel(): number {
    for (let i = 0; i < Levels.length; i++) {
      if (Levels[i] > this.experience) {
        return Levels[i] - this.experience;
      }
    }

    return 99999999;
  }

  public get profile_escaped(): string {
    return markdown.toHTML(this.profile || "");
  }
}
